export const groupByTyped = <
  TObject extends Record<string, any>,
  TKeyProperty extends keyof TObject & string,
  TResult = Partial<{
    [K in TObject[TKeyProperty]]: Array<
      Extract<
        TObject,
        {
          [P in TKeyProperty]: K
        }
      >
    >
  }>,
>(
  list: TObject[],
  groupByProperty: TKeyProperty,
) => {
  const result = {} as TResult

  for (const item of list) {
    const groupKey = item[groupByProperty]
    const group = result[groupKey as any as keyof typeof result]

    if (group) {
      ;(result[groupKey as keyof typeof result] as Array<any>).push(item)
    } else {
      //@ts-ignore
      result[groupKey as keyof typeof result] = [item]
    }
  }

  return result
}
